(function () {
  'use strict';

  angular.module('app').service('AddonModalService', AddonModalService);

  AddonModalService.$inject = ['ModalService'];

  function AddonModalService(ModalService) {
    var service = {
      openAddons: openAddons,
    };

    return service;

    ////////////////

    function openAddons(getItemsCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/admin/addons/modals/addon-list-modal.html',
        controller: AddonListModalCtrl,
        controllerAs: 'vm',
      }).then(function (modal) {
        modal.element.modal();

        modal.element.on('hidden.bs.modal', function () {
          getItemsCallback();
        });
      });
    }

    function AddonListModalCtrl(AddonService, FeatureService, LanguageService) {
      var vm = this;

      vm.items = {};
      vm.meta = {};
      vm.loadingItems = true;
      vm.features = [];
      vm.additionalLanguages = {};

      vm.addItem = addItem;
      vm.onSavedItem = onSavedItem;
      vm.cancel = cancel;
      vm.onCanceledItem = onCanceledItem;
      vm.onShowItem = onShowItem;
      vm.onDeletedItem = onDeletedItem;

      // Initializers
      getItems();
      getFeatures();
      getAdditionalLanguages();

      function getItems() {
        AddonService.getAddons().then(function (data) {
          vm.items = data.items;
          vm.meta = data.meta;

          vm.loadingItems = false;
        });

        vm.modalTitle = 'ADDONS';
      }

      function getFeatures() {
        FeatureService.getFeatures({ get: 'visible_as_addon' }).then(function (data) {
          vm.features = data.items;

          var anyFeature = { id: '', name: 'SHOW_ALL' };
          vm.features.unshift(anyFeature);
        });
      }

      function getAdditionalLanguages() {
        LanguageService.getLanguages({ get: 'translations' }).then(function (data) {
          vm.additionalLanguages = data.items;
        });
      }

      function loadItem(item) {
        AddonService.getAddon(item.id).then(function (data) {
          vm.item = data;
        });
      }

      function addItem() {
        vm.createMode = true;
        vm.item = {};
        vm.modalTitle = 'NEW_ADDON';
      }

      function onSavedItem(item) {
        loadItem(item);
      }

      function cancel() {
        vm.createMode = false;
        vm.editMode = false;

        getItems();
      }

      function onCanceledItem() {
        cancel();
      }

      function onShowItem(item, mode) {
        vm.editMode = true;
        vm.modalTitle = 'ADDON_DETAILS';

        vm.mode = mode;

        loadItem(item);
      }

      function onDeletedItem() {
        cancel();
      }
    }
  }
})();
